import { WallDisplay } from '../parts/tech'
import type { AssetContext, AssetDefinition } from '../types'

/** Chassis sizes, in metres (width x height), bezel included. */
const SIZES = {
  tv55: { width: 1.35, height: 0.78 },
  tv43: { width: 1.06, height: 0.62 },
} as const

/**
 * WALL CONTRACT: `WallDisplay` is modelled around its own centre and its wall
 * bracket reaches back to z = -0.05, so the whole thing is pushed forward by
 * that much — back face on the wall plane at z = 0, everything into +Z.
 */
const WALL_OFFSET = 0.05

/** Wall-mounted presentation display. Accent, when set, tints the picture. */
function TvWall({ accent, variant = 'tv55' }: AssetContext) {
  const size = variant === 'tv43' ? SIZES.tv43 : SIZES.tv55
  return (
    <group position={[0, 0, WALL_OFFSET]}>
      <WallDisplay width={size.width} height={size.height} screenColor={accent} />
    </group>
  )
}

export const definition: AssetDefinition = {
  id: 'tv-wall',
  name: 'Pantalla de pared',
  category: 'tech',
  anchor: 'wall',
  footprint: [1.4, 0.09],
  height: 0.82,
  mountHeight: 1.45,
  accentable: true,
  variants: [
    { id: 'tv55', name: '55 pulgadas' },
    { id: 'tv43', name: '43 pulgadas' },
  ],
  keywords: ['pantalla', 'televisor', 'tv', 'display', 'monitor de pared', 'presentacion', 'presentation'],
  Component: TvWall,
}
